module.exports = __webpack_public_path__ + "static/media/circleFrame4.2fbfc0da.svg";